import { useContext, useEffect, useState } from 'react';
import { FiDownload } from 'react-icons/fi';

import { RebrandShell } from 'components/rebrand/RebrandShell';
import { RegulamentoContent } from 'components/regulamento-content';
import { AuthContext } from 'context/AuthContext';
import { getRegulation, IRegulation } from 'services/regulation.service';

export default function Regulamento() {
  const [regulation, setRegulation] = useState<IRegulation>();
  const { user } = useContext(AuthContext);

  useEffect(() => {
    async function loadData() {
      const data = await getRegulation(user?.extra.rede);
      if (data) setRegulation(data);
    }

    loadData();
  }, [user?.extra.rede]);

  return (
    <RebrandShell title="Regulamento" subtitle="As regras completas do Reconheça BRB.">
      {regulation?.regulation?.url && (
        <a
          className="rb-btn-ghost"
          href={regulation.regulation.url}
          target="_blank"
          rel="noreferrer"
          style={{ display: 'inline-flex', alignItems: 'center', gap: 8, marginBottom: 24 }}
        >
          <FiDownload size={16} /> Baixar PDF das regras
        </a>
      )}

      <div className="rb-regulamento">
        <RegulamentoContent rede={user?.extra.rede} />
      </div>
    </RebrandShell>
  );
}
